import {
  SET_EMAIL,
  RECOVERY_EMAIL_REQUEST,
  RECOVERY_EMAIL_SUCCESS,
  RECOVERY_EMAIL_FAILURE
} from 'constants/actionTypes';

export function setEmail(value) {
  return {
    type: SET_EMAIL,
    value
  };
}

export function sendRecoveryEmail() {
  return {
    type: RECOVERY_EMAIL_REQUEST
  };
}

export function recoveryEmailSuccess(email) {
  return {
    type: RECOVERY_EMAIL_SUCCESS,
    email
  };
}

export function recoveryEmailFailure(errorText) {
  return {
    type: RECOVERY_EMAIL_FAILURE,
    errorText
  };
}
